import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { SignupOverviewList } from "./signup-list.model";
import { JQueryHelperService } from "../../shared/models/jquery-helper.service";


@Injectable()
export class SignupListService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public GetSignupList(signupOverviewList: SignupOverviewList, input?: DataListModel): Observable<IAPIResponse> {
    let url = WeGoConfig.API_GET_SIGNUP_LIST;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringBookingOverviewModel = this.JQueryHelper.Param(signupOverviewList);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    url = url + "?" + queryStringDataListModel + "&" + decodeURIComponent(queryStringBookingOverviewModel);
    return this.http.get(url, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportSignupList(signupOverviewList: SignupOverviewList, input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let url = WeGoConfig.API_EXPORT_SIGNUP_LIST;
    let queryStringBookingOverviewModel = this.JQueryHelper.Param(signupOverviewList);
    url = url + "?" + queryString + "&" + decodeURIComponent(queryStringBookingOverviewModel);

    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(url, options);
  }

  public AcceptRejectSignup(signupOverviewList: SignupOverviewList, Accept: boolean, Reject: boolean): Observable<IAPIResponse> {

    let url = WeGoConfig.API_ACCEPT_REJECT_SIGNUP;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    url = url + "?Accept=" + Accept + "&Reject=" + Reject;
    return this.http.post(url, signupOverviewList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signupform/models/signup-list.service.ts